export { ConsoleInstrumentation } from './instrumentation';

export type { ConsoleInstrumentationOptions } from './types';
